import api from "../../../core/api";
import { ServiceProviderSettings, ChangeServiceProviderSettings } from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.servicingApiBaseUrl };
};

class ServiceProviderSettingsApi {
  getSettingsAsync(): Promise<ServiceProviderSettings> {
    return api.get<ServiceProviderSettings>(`/v1/customer/service-provider-settings`, getRequestConfig())
      .then(x => x.data);
  }

  updateSettingsAsync(settings: ChangeServiceProviderSettings): Promise<ServiceProviderSettings> {
    return api.put<ServiceProviderSettings>(`/v1/customer/service-provider-settings`, settings, getRequestConfig())
      .then(x => x.data);
  }
}

export default new ServiceProviderSettingsApi();
